import { render, staticRenderFns } from "./TwoFactorAuthenticationDialog.vue?vue&type=template&id=80b0f2b8"
import script from "./TwoFactorAuthenticationDialog.vue?vue&type=script&lang=js"
export * from "./TwoFactorAuthenticationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports